import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken, ok } from '../../utils/response';
import { errorResponse, okResponse, notFoundResponse } from '../../utils/response';
import { Token, UserCode, EmployeeId, EmployeeCode, Company } from '../../utils/users';
import { IsEnglish } from '../../utils/language';
import { encryption } from '../../utils/encryption';

export function getSurveyList() {
    let url = 'survey/getSurveyList?' + objectToQueryString(
        {
            userCode: encryption(UserCode()),
            employeeCode: encryption(EmployeeCode()),
            company: encryption(Company()),
            token: Token()
        });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getSurveyDetail(id) {
    let url = 'survey/getSurveyDetail?' + objectToQueryString(
        {
            userCode: encryption(UserCode()),
            surveyId: encryption(id),
            token: Token()
        });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getSurveyQuestion(id) {
    let url = 'survey/getSurveyQuestion?' + objectToQueryString(
        {
            userCode: encryption(UserCode()),
            surveyId: encryption(id),
            token: Token()
        });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function saveSurvey(surveyId, questions) {
    const questionsCrypt = [];

    questions.forEach(x => {
        const obj = {
            valueType: x.valueType,
            value: x.value,
            evaluationForm2IdCrypt: encryption(x.evaluationForm2Id)
        }

        questionsCrypt.push(obj);
    });

    const obj = {
        userCodeCrypt: encryption(UserCode()),
        surveyIdCrypt: encryption(surveyId),
        questionsCrypt: questionsCrypt
    };

    return fetch('survey/SaveSurvey', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            surveyIdCrypt: encryption(surveyId),
            questionsCrypt: questionsCrypt,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}
